// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});

// Title Underline Animation
document.addEventListener('DOMContentLoaded', () => {
    const spans = document.querySelectorAll('.heading span');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('visible');
                }, 800);
            } else {
                entry.target.classList.remove('visible');
            }
        });
    }, { root: null, rootMargin: '0px', threshold: 0.3 });

    spans.forEach(s => observer.observe(s));
});

//sticky scroll
jQuery(function ($) {
    initStickyContent();

    function initStickyContent() {
        const $blocks = $(".sticky-media-object");
        if (!$blocks.length) return;

        $blocks.each(function () {
            const $block = $(this);
            const $items = $block.find(".right-content__item ");
            const $media = $block.find(".left-content__item");
            const $row = $block.find(".row");
            const $left = $block.find(".left-content");

            if ($items.length && $media.length) {
                $items.removeClass("active").first().addClass("active");
                $media.removeClass("active").first().addClass("active");
            }

            function applyBottomPadding() {
                if (!$left.length || !$row.length) return;
                if (window.innerWidth <= 992) {
                    $row.css("padding-bottom", "");
                    return;
                }

                var topPx =
                    parseInt(window.getComputedStyle($left[0]).top, 10) || 120;
                var leftH = $left.outerHeight();
                var vh =
                    window.innerHeight || document.documentElement.clientHeight;

                var extra = Math.max(0, leftH - (vh - topPx));
                $row.css("padding-bottom", extra + 32 + "px");
            }

            applyBottomPadding();
            $(window).on("load resize", applyBottomPadding);

            $block.find("img").on("load", applyBottomPadding);

            function checkFeatureVisibility() {
                if (window.innerWidth <= 992) return;

                const scrollTop = $(window).scrollTop();
                const windowHeight = $(window).height();
                const triggerLine = scrollTop + windowHeight * 0.4;

                let activeIndex = 0;
                let minDistance = Number.POSITIVE_INFINITY;

                $items.each(function (index) {
                    const $item = $(this);
                    const itemTop = $item.offset().top;
                    const itemH = $item.outerHeight();
                    const center = itemTop + itemH / 2;
                    const dist = Math.abs(triggerLine - center);

                    if (dist < minDistance) {
                        minDistance = dist;
                        activeIndex = index;
                    }
                });

                activateFeature(activeIndex);
            }

            function activateFeature(index) {
                $items.removeClass("active").eq(index).addClass("active");
                $media.removeClass("active").eq(index).addClass("active");
            }

            $(window).on("scroll", checkFeatureVisibility);
            $items.on("click", function () {
                if (window.innerWidth <= 992) return;
                const index = $(this).data("item");
                activateFeature(index);
            });

            checkFeatureVisibility();
        });
    }
});

// Sticky Vertical Numbered Slider

document.addEventListener('DOMContentLoaded', function () {
    const mq = window.matchMedia('(min-width: 992px)');
    let numbers = [];
    let slides = [];
    let lastActive = null;
    let ticking = false;
    let scrollHandler = null;
    let resizeHandler = null;
    let clickRemovers = [];

    function clearActiveNumbers() {
        numbers.forEach(n => n.classList.remove('active'));
    }
    function clearActiveSlides() {
        slides.forEach(s => s.classList.remove('active'));
    }

    function setActive(val) {
        if (val === lastActive && document.querySelector('.stick-number.active')) return;

        lastActive = val;
        const v = String(val).trim();

        requestAnimationFrame(() => {
            clearActiveNumbers();
            clearActiveSlides();

            numbers.forEach(n => {
                const ns = (n.getAttribute('data-slide') || '').trim();
                if (ns === v) n.classList.add('active');
            });
            slides.forEach(s => {
                const ss = (s.getAttribute('data-slide') || '').trim();
                if (ss === v) s.classList.add('active');
            });
        });
    }

    function fallback() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
            const vpCenter = window.innerHeight / 2;
            let best = null;
            let bestDist = Infinity;

            slides.forEach(s => {
                const r = s.getBoundingClientRect();
                const center = r.top + (r.height / 2);
                const dist = Math.abs(vpCenter - center);
                if (dist < bestDist) {
                    bestDist = dist;
                    best = s;
                }
            });

            if (best) {
                const val = (best.getAttribute('data-slide') || '').trim();
                if (val && val !== lastActive) {
                    setActive(val);
                }
            }
            ticking = false;
        });
    }

    function onNumberClick(e) {
        e.preventDefault();
        const n = e.currentTarget;
        const target = (n.getAttribute('data-slide') || '').trim();
        if (!target) return;
        const slide = slides.find(s => (s.getAttribute('data-slide') || '').trim() === target);

        if (slide) {
            slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setActive(target);
        }
    }

    function enable() {
        numbers = Array.from(document.querySelectorAll('.stick-number'));
        slides = Array.from(document.querySelectorAll('.sticky-vertical-numbered-slider__slide'));
        lastActive = null;

        scrollHandler = fallback;
        resizeHandler = fallback;

        window.addEventListener('scroll', scrollHandler, { passive: true });
        window.addEventListener('resize', resizeHandler);

        numbers.forEach(n => {
            n.addEventListener('click', onNumberClick);
            clickRemovers.push({ el: n, fn: onNumberClick });
        });

        fallback();
    }

    function disable() {
        if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
        }
        if (resizeHandler) {
            window.removeEventListener('resize', resizeHandler);
            resizeHandler = null;
        }

        clickRemovers.forEach(item => item.el.removeEventListener('click', item.fn));
        clickRemovers = [];

        numbers = Array.from(document.querySelectorAll('.stick-number'));
        slides = Array.from(document.querySelectorAll('.sticky-vertical-numbered-slider__slide'));

        clearActiveNumbers();
        clearActiveSlides();

        if (slides.length) {
            const firstVal = slides[0].getAttribute('data-slide');
            setActive(firstVal);
        }
    }

    function handleChange(matches) {
        if (matches) {
            enable();
        } else {
            disable();
        }
    }

    handleChange(mq.matches);

    if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', e => handleChange(e.matches));
    } else if (typeof mq.addListener === 'function') {
        mq.addListener(m => handleChange(m.matches));
    }
});

//Sticky Horizontal Numbered Slider
(function ($) {
    var slider = $('.sticky-vertical-numbered-slider__sliders');
    var slides = $('.sticky-vertical-numbered-slider__slide');
    var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: false,
        centerMode: false,
        variableWidth: false,
        customPaging: function (slick, index) {
            var number = index + 1;
            return '<button class="slick-number">' + number.toString().padStart(2, '0') + '</button>';
        }
    };

    function initOrDestroy() {
        var windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (!slider.hasClass('slick-initialized')) {
                slides.removeClass('active');
                slider.slick(options);
            }
        } else {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
    }

    $(window).on('load resize', function () {
        initOrDestroy();
    });
})(jQuery);

// Sticky Offices Slider vertical
document.addEventListener('DOMContentLoaded', function () {
    const mq = window.matchMedia('(min-width: 992px)');
    let numbers = [];
    let slides = [];
    let lastActive = null;
    let ticking = false;
    let scrollHandler = null;
    let resizeHandler = null;
    let clickRemovers = [];

    function clearActiveNumbers() {
        numbers.forEach(n => n.classList.remove('active'));
    }
    function clearActiveSlides() {
        slides.forEach(s => s.classList.remove('active'));
    }

    function setActive(val) {
        if (val === lastActive && document.querySelector('.stick-number.active')) return;

        lastActive = val;
        const v = String(val).trim();
        requestAnimationFrame(() => {
            clearActiveNumbers();
            clearActiveSlides();

            numbers.forEach(n => {
                const ns = (n.getAttribute('data-slide') || '').trim();
                if (ns === v) n.classList.add('active');
            });
            slides.forEach(s => {
                const ss = (s.getAttribute('data-slide') || '').trim();
                if (ss === v) s.classList.add('active');
            });
        });
    }

    function fallback() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
            const vpCenter = window.innerHeight / 2;
            let best = null;
            let bestDist = Infinity;

            slides.forEach(s => {
                const r = s.getBoundingClientRect();
                const center = r.top + (r.height / 2);
                const dist = Math.abs(vpCenter - center);

                if (dist < bestDist) {
                    bestDist = dist;
                    best = s;
                }
            });

            if (best) {
                const val = (best.getAttribute('data-slide') || '').trim();
                if (val && val !== lastActive) {
                    setActive(val);
                }
            }
            ticking = false;
        });
    }

    function onNumberClick(e) {
        e.preventDefault();
        const n = e.currentTarget;
        const target = (n.getAttribute('data-slide') || '').trim();
        if (!target) return;
        const slide = slides.find(s => (s.getAttribute('data-slide') || '').trim() === target);

        if (slide) {
            slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setActive(target);
        }
    }

    function enable() {
        numbers = Array.from(document.querySelectorAll('.stick-number'));
        slides = Array.from(document.querySelectorAll('.sticky-offices-slider__slide'));
        lastActive = null;

        scrollHandler = fallback;
        resizeHandler = fallback;

        window.addEventListener('scroll', scrollHandler, { passive: true });
        window.addEventListener('resize', resizeHandler);

        numbers.forEach(n => {
            n.addEventListener('click', onNumberClick);
            clickRemovers.push({ el: n, fn: onNumberClick });
        });

        fallback();
    }

    function disable() {
        if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
        }
        if (resizeHandler) {
            window.removeEventListener('resize', resizeHandler);
            resizeHandler = null;
        }

        clickRemovers.forEach(item => item.el.removeEventListener('click', item.fn));
        clickRemovers = [];

        numbers = Array.from(document.querySelectorAll('.stick-number'));
        slides = Array.from(document.querySelectorAll('.sticky-offices-slider__slide'));

        clearActiveNumbers();
        clearActiveSlides();

        if (slides.length) {
            const firstVal = slides[0].getAttribute('data-slide');
            setActive(firstVal);
        }
    }

    function handleChange(matches) {
        if (matches) {
            enable();
        } else {
            disable();
        }
    }

    handleChange(mq.matches);

    if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', e => handleChange(e.matches));
    } else if (typeof mq.addListener === 'function') {
        mq.addListener(m => handleChange(m.matches));
    }
});

//Sticky Offices Slider horizontal
(function ($) {
    var slider = $('.sticky-offices-slider__sliders');
    var slides = $('.sticky-offices-slider__slide');
    var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        infinite: false,
        adaptiveHeight: false,
        centerMode: false,
        variableWidth: false,
        customPaging: function (slick, index) {
            var number = index + 1;
            return '<button class="slick-number">' + number.toString().padStart(2, '0') + '</button>';
        }
    };

    function initOrDestroy() {
        var windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (!slider.hasClass('slick-initialized')) {
                slides.removeClass('active');
                slider.slick(options);
            }
        } else {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
    }

    $(window).on('load resize', function () {
        initOrDestroy();
    });
})(jQuery);

// Logos cloud animation
jQuery(document).ready(function ($) {
    const INTERVAL = 6000;
    const container = $('.logos-cloud__content-wrapper--logos');
    const items = container.find('.content--item');

    let visible = items.filter(function () {
        return this.className.includes('active_');
    });

    let hidden = items.filter('.hidden');
    let queue = hidden.toArray();

    let lastEntered = null;

    setInterval(function () {
        if (queue.length === 0) return;

        let eligible = visible.toArray().filter(v => v !== lastEntered);

        if (eligible.length === 0) {
            eligible = visible.toArray();
        }

        const removeItem = $(eligible[Math.floor(Math.random() * eligible.length)]);

        const classes = removeItem.attr('class').split(/\s+/);
        const activeClass = classes.find(c => c.startsWith('active_'));

        removeItem.removeClass(activeClass).addClass('hidden');

        const addItem = $(queue.shift());

        addItem.removeClass('hidden').addClass(activeClass);

        visible = items.filter(function () {
            return this.className.includes('active_');
        });

        hidden = items.filter('.hidden');
        queue.push(removeItem[0]);
        lastEntered = addItem[0];

    }, INTERVAL);
});


// Tabbed Tables - Duplicate Bottom Tabs
document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.tabbed-tables');
    var scrollTarget = document.querySelector('.tabbed-tables__wrapper') || container;

    if (!container) return;

    var tabEls = container.querySelectorAll('li[data-bs-toggle="tab"]');

    tabEls.forEach(function (tabEl) {
        tabEl.addEventListener('show.bs.tab', function (event) {
            if (event.target.closest('.nav-bottom')) {
                setTimeout(function () {
                    scrollTarget.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 150);
            }
            var targetSelector = event.target.getAttribute('data-bs-target');
            var relatedTabs = container.querySelectorAll('li[data-bs-target="' + targetSelector + '"]');

            relatedTabs.forEach(function (el) {
                if (el !== event.target) {
                    var parentUl = el.closest('ul');
                    if (parentUl) {
                        var siblings = parentUl.querySelectorAll('.active');
                        siblings.forEach(function (sib) {
                            sib.classList.remove('active');
                            sib.setAttribute('aria-selected', 'false');
                        });
                    }
                    el.classList.add('active');
                    el.setAttribute('aria-selected', 'true');
                }
            });
        });
    });
});

// Tabbed Tables - Drag to Scroll
document.addEventListener("DOMContentLoaded", function () {
    const tables = document.querySelectorAll(
        ".tabbed-tables__tabs--content-table"
    );
    if (!tables.length) return;

    tables.forEach((el) => {
        let isDown = false;
        let startX;
        let scrollLeft;

        el.addEventListener("mousedown", (e) => {
            isDown = true;
            el.classList.add("active");
            startX = e.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft;
        });

        el.addEventListener("mouseleave", () => {
            isDown = false;
        });

        el.addEventListener("mouseup", () => {
            isDown = false;
        });

        el.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - el.offsetLeft;
            const walk = (x - startX) * 1;
            el.scrollLeft = scrollLeft - walk;
        });
    });
});

// Smooth scroll to center the question when an FAQ is opened
document.addEventListener('DOMContentLoaded', () => {
    const detailsElements = document.querySelectorAll('.faq-list details');

    detailsElements.forEach(details => {
        details.addEventListener('toggle', function () {

            if (this.open) {
                const summary = this.querySelector('summary');

                summary.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        });
    });
});

/* Slider Featured Case Studies */
jQuery(document).ready(function ($) {
    var slideCount = $('.slider-featured-case-studies .slider .slide').length;

    $('.slider-featured-case-studies .slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: slideCount > 1,
        dots: false,
        infinite: slideCount > 1,
        speed: 500,
        adaptiveHeight: true,
        fade: false,
        cssEase: 'ease-in-out',
        prevArrow: '.slider-featured-case-studies .slick-prev',
        nextArrow: '.slider-featured-case-studies .slick-next',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    AOS.refresh();

    // Update the counter when the slide changes.
    $('.slider-featured-case-studies .slider').on('afterChange', function (event, slick, currentSlide) {
        $('.slider-featured-case-studies .slider-counter .current').text(currentSlide + 1);
    });
});

/* Slider Process Block */
document.addEventListener('DOMContentLoaded', function () {
    const sliderWrappers = document.querySelectorAll('.slider-process .slider-wrapper');

    sliderWrappers.forEach(slider => {
        const cards = slider.querySelectorAll('.card');
        const images = slider.querySelectorAll('.animated');
        const scrollIndicator = slider.querySelector('.scroll');
        
        const FIXED_INDICATOR_HEIGHT = 144;

        function updateScrollPosition(index) {
            if (scrollIndicator && cards.length > 0) {
                const totalCards = cards.length;

                scrollIndicator.style.setProperty('--indicator-height', FIXED_INDICATOR_HEIGHT + 'px');

                const progress = index / (totalCards - 1);

                scrollIndicator.style.setProperty('--scroll-progress', progress);
            }
        }

        cards.forEach((card, index) => {
            card.addEventListener('click', function () {
                const slideIndex = this.getAttribute('data-slide');

                cards.forEach(c => c.classList.remove('active'));
                images.forEach(img => img.classList.remove('active'));

                this.classList.add('active');
                const activeImage = slider.querySelector(`.animated[data-slide="${slideIndex}"]`);
                if (activeImage) {
                    activeImage.classList.add('active');
                }
                updateScrollPosition(parseInt(slideIndex));
            });
        });

        updateScrollPosition(0);
        window.addEventListener('resize', function () {
            const activeCard = slider.querySelector('.card.active');
            if (activeCard) {
                const activeIndex = parseInt(activeCard.getAttribute('data-slide'));
                updateScrollPosition(activeIndex);
            }
        });
    });
});


jQuery(document).ready(function ($) {
    setTimeout(() => {
        document.querySelectorAll('.form-script form label').forEach(label => {
            const span = label.querySelector('span');
            if (span && !span.textContent.trim()) {
                label.style.display = 'none';
            }
        });
    }, 2000);
});

